export const CHECKOUT_CUSTOMER_PENDINGS = 'customer-pendings'
export const CHECKOUT_PAYMENT_METHODS = 'payment-methods'
export const CHECKOUT_PAYMENT_CONFIRMATION = 'payment-confirmation'
